import { commonjsGlobal } from "../../../_virtual/_commonjsHelpers.js";
import { d as duo_web_sdk } from "../../../_virtual/index.js";
(function(root, factory) {
  duo_web_sdk.exports = factory();
})(commonjsGlobal, function() {
  var DUO_MESSAGE_FORMAT = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/;
  var DUO_ERROR_FORMAT = /^ERR\|[\w\s\.\(\)]+$/;
  var DUO_OPEN_WINDOW_FORMAT = /^DUO_OPEN_WINDOW\|/;
  var VALID_OPEN_WINDOW_DOMAINS = ["duo.com", "duosecurity.com", "duomobile.s3-us-west-1.amazonaws.com"];
  var postAction, postArgument, host, duoSig, appSig, iframe;
  initializeStatefulVariables();
  function initializeStatefulVariables() {
    postAction = "";
    postArgument = "sig_response";
    host = void 0;
    duoSig = void 0;
    appSig = void 0;
    iframe = void 0;
  }
  function throwError(message, givenUrl) {
    var url = givenUrl || "https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe";
    throw new Error("Duo Web SDK error: " + message + (url ? "\nSee " + url + " for more information" : ""));
  }
  function hyphenize(str) {
    return str.replace(/([a-z])([A-Z])/, "$1-$2").toLowerCase();
  }
  function getDataAttribute(element, name) {
    if ("dataset" in element) {
      return element.dataset[name];
    } else {
      return element.getAttribute("data-" + hyphenize(name));
    }
  }
  function on(context, event, fallbackEvent, callback) {
    if ("addEventListener" in window) {
      context.addEventListener(event, callback, false);
    } else {
      context.attachEvent(fallbackEvent, callback);
    }
  }
  function off(context, event, fallbackEvent, callback) {
    if ("removeEventListener" in window) {
      context.removeEventListener(event, callback, false);
    } else {
      context.detachEvent(fallbackEvent, callback);
    }
  }
  function onReady(callback) {
    on(document, "DOMContentLoaded", "onreadystatechange", callback);
  }
  function offReady(callback) {
    off(document, "DOMContentLoaded", "onreadystatechange", callback);
  }
  function onMessage(callback) {
    on(window, "message", "onmessage", callback);
  }
  function offMessage(callback) {
    off(window, "message", "onmessage", callback);
  }
  function parseSigRequest(sig) {
    if (!sig) {
      return;
    }
    if (sig.indexOf("ERR|") === 0) {
      throwError(sig.split("|")[1]);
    }
    if (sig.indexOf(":") === -1 || sig.split(":").length !== 2) {
      throwError("Duo was given a bad token.  This might indicate a configuration problem with one of Duo's client libraries.");
    }
    var sigParts = sig.split(":");
    duoSig = sigParts[0];
    appSig = sigParts[1];
    return {
      sigRequest: sig,
      duoSig: sigParts[0],
      appSig: sigParts[1]
    };
  }
  function isDuoMessage(event) {
    return Boolean(event.origin === "https://" + host && typeof event.data === "string" && (event.data.match(DUO_MESSAGE_FORMAT) || event.data.match(DUO_ERROR_FORMAT) || event.data.match(DUO_OPEN_WINDOW_FORMAT)));
  }
  function init(options) {
    initializeStatefulVariables();
    if (options) {
      if (options.host) {
        host = options.host;
      }
      if (options.sig_request) {
        parseSigRequest(options.sig_request);
      }
      if (options.post_action) {
        postAction = options.post_action;
      }
      if (options.post_argument) {
        postArgument = options.post_argument;
      }
      if (typeof options.submit_callback === "function") {
        options.submit_callback;
      }
    }
    var promptElement = getPromptElement(options);
    if (promptElement) {
      ready(promptElement, options.iframeAttributes || {});
    } else {
      asyncReady(options);
    }
    offReady(init);
  }
  function getPromptElement(options) {
    var result;
    if (options.iframe && options.iframeContainer) {
      throwError("Passing both `iframe` and `iframeContainer` arguments at the same time is not allowed.");
    } else if (options.iframe) {
      result = getUserDefinedElement(options.iframe);
      validateIframe(result);
    } else if (options.iframeContainer) {
      result = getUserDefinedElement(options.iframeContainer);
      validateIframeContainer(result);
    } else {
      result = document.getElementById("duo_iframe");
    }
    return result;
  }
  function getUserDefinedElement(object) {
    if (object.tagName) {
      return object;
    } else if (typeof object == "string") {
      return document.getElementById(object);
    }
    return null;
  }
  function isIframe(element) {
    return element && element.tagName && element.tagName.toLowerCase() === "iframe";
  }
  function validateIframe(element) {
    if (element && !isIframe(element)) {
      throwError("`iframe` only accepts an iframe element or the id of an iframe. To use a non-iframe element, use the `iframeContainer` argument.");
    }
  }
  function validateIframeContainer(element) {
    if (element && isIframe(element)) {
      throwError("`iframeContainer` only accepts a non-iframe element or the id of a non-iframe. To use a non-iframe element, use the `iframeContainer` argument on Duo.init().");
    }
  }
  function generateIframeSrc() {
    return ["https://", host, "/frame/web/v1/auth?tx=", duoSig, "&parent=", encodeURIComponent(document.location.href), "&v=2.8"].join("");
  }
  function onReceivedMessage(event) {
    if (isDuoMessage(event)) {
      if (event.data.match(DUO_OPEN_WINDOW_FORMAT)) {
        var url = event.data.substring("DUO_OPEN_WINDOW|".length);
        if (isValidUrlToOpen(url)) {
          window.open(url, "_self");
        }
      } else {
        doPostBack(event.data);
        offMessage(onReceivedMessage);
      }
    }
  }
  function isValidUrlToOpen(url) {
    if (!url) {
      return false;
    }
    var parser = document.createElement("a");
    parser.href = url;
    if (parser.protocol === "duotrustedendpoints:") {
      return true;
    } else if (parser.protocol !== "https:") {
      return false;
    }
    for (var i = 0; i < VALID_OPEN_WINDOW_DOMAINS.length; i++) {
      if (parser.hostname.endsWith("." + VALID_OPEN_WINDOW_DOMAINS[i]) || parser.hostname === VALID_OPEN_WINDOW_DOMAINS[i]) {
        return true;
      }
    }
    return false;
  }
  function asyncReady(options) {
    var callback = function() {
      var promptElement = getPromptElement(options);
      if (!promptElement) {
        throwError('This page does not contain an iframe for Duo to use. Add an element like <iframe id="duo_iframe"></iframe> to this page.');
      }
      ready(promptElement, options.iframeAttributes || {});
      offReady(callback);
    };
    onReady(callback);
  }
  function ready(promptElement, iframeAttributes) {
    if (!host) {
      host = getDataAttribute(promptElement, "host");
      if (!host) {
        throwError("No API hostname is given for Duo to use.  Be sure to pass a `host` parameter to Duo.init, or through the `data-host` attribute on the iframe element.");
      }
    }
    if (!duoSig || !appSig) {
      parseSigRequest(getDataAttribute(promptElement, "sigRequest"));
      if (!duoSig || !appSig) {
        throwError("No valid signed request is given.  Be sure to give the `sig_request` parameter to Duo.init, or use the `data-sig-request` attribute on the iframe element.");
      }
    }
    if (postAction === "") {
      postAction = getDataAttribute(promptElement, "postAction") || postAction;
    }
    if (postArgument === "sig_response") {
      postArgument = getDataAttribute(promptElement, "postArgument") || postArgument;
    }
    if (isIframe(promptElement)) {
      iframe = promptElement;
      iframe.src = generateIframeSrc();
    } else {
      while (promptElement.firstChild) {
        promptElement.removeChild(promptElement.firstChild);
      }
      iframe = document.createElement("iframe");
      iframeAttributes["src"] = generateIframeSrc();
      for (var name in iframeAttributes) {
        iframe.setAttribute(name, iframeAttributes[name]);
      }
      promptElement.appendChild(iframe);
    }
    onMessage(onReceivedMessage);
  }
  function doPostBack(response) {
    postAction(response + ":" + appSig);
  }
  return {
    init,
    _onReady: onReady,
    _parseSigRequest: parseSigRequest,
    _isDuoMessage: isDuoMessage,
    _doPostBack: doPostBack
  };
});
var Duo = duo_web_sdk.exports;
export { Duo as default };
